import Toastr from '../../../itrust_common/components/Toastr';

const DEFAULT_STATE = {
  promotions: [],
  meta: {},
  preview: null,
  loading: false,
  previewLoading: false,
  saving: false,
  error: null,
};

export default function orderPromotionReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'ORDER_PROMOTIONS_LOAD_PENDING':
      return { ...state, loading: true, error: null };

    case 'ORDER_PROMOTIONS_LOAD_FULFILLED': {
      const page = action.meta?.page;
      const isFirstPage =
        page === 1 ||
        (!page && (!response?.meta?.pagination?.from || response?.meta?.pagination?.from === 1));

      const incoming = response?.promotions || [];
      let promotions = incoming;
      if (!isFirstPage) {
        const existingIds = new Set((state.promotions || []).map((p) => p.id));
        promotions = [...(state.promotions || []), ...incoming.filter((p) => !existingIds.has(p.id))];
      }

      return {
        ...state,
        loading: false,
        promotions,
        meta: response?.meta || {},
        error: null,
      };
    }

    case 'ORDER_PROMOTIONS_RESET':
      return {
        ...state,
        promotions: [],
        meta: {},
        loading: false,
      };

    case 'ORDER_PROMOTIONS_LOAD_REJECTED':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'ORDER_PROMOTION_PREVIEW_LOAD_PENDING':
      return { ...state, previewLoading: true, error: null };

    case 'ORDER_PROMOTION_PREVIEW_LOAD_FULFILLED':
      return {
        ...state,
        previewLoading: false,
        preview: response?.promotion || null,
        error: null,
      };

    case 'ORDER_PROMOTION_PREVIEW_LOAD_REJECTED':
      return {
        ...state,
        previewLoading: false,
        preview: null,
        error: action.payload,
      };

    case 'ORDER_PROMOTION_APPLY_PENDING':
    case 'ORDER_PROMOTION_REMOVE_PENDING':
      return { ...state, saving: true, error: null };

    case 'ORDER_PROMOTION_APPLY_FULFILLED':
    case 'ORDER_PROMOTION_REMOVE_FULFILLED':
      return {
        ...state,
        saving: false,
        error: null,
      };

    case 'ORDER_PROMOTION_APPLY_REJECTED':
    case 'ORDER_PROMOTION_REMOVE_REJECTED': {
      const errData = response?.data;
      if (errData) {
        Toastr.handleShow(errData.success, errData.error, errData.status_code);
      }
      return {
        ...state,
        saving: false,
        error: action.payload,
      };
    }

    case 'ORDER_PROMOTION_PREVIEW_CLEAR':
      return { ...state, preview: null, previewLoading: false };

    default:
      return state;
  }
}
